import { connect } from 'react-redux';
import selectFlags from './selectFlags';

export default connect(selectFlags);
